import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { RouterModule } from '@angular/router';
import { NgxUploaderModule } from 'ngx-uploader-esb';

import { DayInputModule } from '../day-input/day-input.module';
import { PipesModule } from '../pipes/pipes.module';
import { SharedModule } from '../shared/shared.module';
import { CommissionDetailsComponent } from './components/commission-details/commission-details.component';
import { CommissionDetailsNewComponent } from './components/commission-details-new/commission-details-new.component';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule,
    MatProgressSpinnerModule,
    SharedModule,
    MatButtonModule,
    MatTabsModule,
    MatTableModule,
    MatSortModule,
    MatDialogModule,
    DayInputModule,
    MatFormFieldModule,
    MatSelectModule,
    MatDatepickerModule,
    MatDividerModule,
    ReactiveFormsModule,
    NgxUploaderModule,
    MatIconModule,
    MatInputModule,
    FormsModule,
    PipesModule,
    MatPaginatorModule,
    CommissionDetailsComponent,
    CommissionDetailsNewComponent,
  ],
  exports: [CommissionDetailsComponent, CommissionDetailsNewComponent],
})
export class CommissionDetailsModule {}
